const NON_DIGIT = /\D/g;

/** Returns up to 10 US national digits (strips non-digits; removes leading country code 1). */
export function parseUsPhoneToDigits(input: string | null | undefined): string {
  if (input === null || input === undefined || typeof input !== 'string') return '';
  let d = input.replace(NON_DIGIT, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  return d.slice(0, 10);
}

/** True when stored value parses to exactly 10 US digits. */
export function hasFormattedUsSupportPhone(stored: string | null | undefined): boolean {
  return parseUsPhoneToDigits(stored).length === 10;
}

/**
 * Display as (###) ###-#### for full numbers; progressive mask while typing partial input.
 */
export function formatUsPhoneUi(input: string | null | undefined): string {
  const d = parseUsPhoneToDigits(input);
  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** E.164-style href segment for tel: URLs; undefined if not a complete US mobile/line. */
export function telHrefFromStoredPhone(input: string | null | undefined): string | undefined {
  const d = parseUsPhoneToDigits(input);
  if (d.length !== 10) return undefined;
  return `+1${d}`;
}

/** Normalize for branding_config persistence (10-digit string only). */
export function normalizeSupportPhoneForStorage(input: string | null | undefined): string | null {
  const d = parseUsPhoneToDigits(input);
  return d.length === 10 ? d : null;
}

/** Local-part@domain.tld shape (requires a dot in the domain). */
const LIKELY_EMAIL_WITH_TLD = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Lenient validation for portal support inbox (empty ok). */
export function isLikelyOrganizationSupportEmail(raw: string): boolean {
  const s = raw.trim();
  if (!s) return true;
  return LIKELY_EMAIL_WITH_TLD.test(s);
}

/**
 * Required invite / recipient email: non-empty and must include a domain TLD
 * (rejects addresses like `user@company` that pass a bare `@` check).
 */
export function isValidInviteEmail(raw: string): boolean {
  const s = raw.trim();
  if (!s) return false;
  return LIKELY_EMAIL_WITH_TLD.test(s);
}

export const INVITE_EMAIL_VALIDATION_MESSAGE =
  'Enter a full email address including the domain (example@company.com).';
